import type { Profile } from "@frontier/protocol/contracts";
import { tutorialCount, tutorialMilestones, tutorialStage } from "@frontier/content/tutorial";
import { moduleLabels } from "./ui-labels";
import { trainingInstallInstruction } from "./onboarding-ui";

export function TrainingDockPanel({ profile, busy, onAccept, equipmentAction = "inspect", replacement = null }: {
  profile: Profile; busy: boolean; onAccept?: (() => Promise<void>) | undefined; equipmentAction?: "inspect" | "cell" | "install";
  replacement?: string | null;
}) {
  const tutorial = profile.tutorial;
  if (tutorial?.version !== 2 || tutorial.docked) return null;
  const stage = tutorialStage(tutorial);
  const contract = profile.contracts.find(item => item.contractId === "intro");
  const accepting = stage === "contractAccepted";
  const rewardName = moduleLabels.volley;
  return <section className="training-dock-panel" aria-label="Текущий шаг обучения" role="status" aria-atomic="true">
    <span className="eyebrow">УЧЕБНЫЙ ДОК · {tutorialCount(tutorial)}/{tutorialMilestones(tutorial).length}</span>
    <h2>{accepting ? "Первый контракт: помощь транспорту" : stage === "moduleEquipped" ? "Контракт выполнен · награда на складе" :
      stage === "moduleUsed" ? "Корабль оснащён — пора испытать модуль" : stage === "return" ? "Обучение пройдено — впереди открытый мир" : "Учебный контракт выполняется"}</h2>
    <p className="training-dock-context">{accepting ? "Ты в учебном доке. Контракт — работа за награду: защити транспорт «Орион» и доставь груз сюда." :
      stage === "moduleEquipped" ? `За доставку груза ты получил «${rewardName}»: он усиливает выстрел орудия и включается вручную в полёте.` :
      stage === "moduleUsed" ? `«${rewardName}» теперь на корабле. Кнопка применения появится в полёте; после выстрела модуль перезаряжается.` :
      stage === "return" ? "Три портала ведут на базы разных фракций. Выбор постоянный; после перехода ты сам выбираешь контракты и маршрут." :
      "Ты вернулся в учебный док. Задание ещё идёт: помоги транспорту и доставь груз, чтобы получить награду."}</p>
    {accepting && !contract ? <p role="alert">Не удалось загрузить учебный контракт. Переподключись к игре, прогресс сохранён.</p> : accepting && contract ? <button className="contract-route training-contract" disabled={busy || !onAccept}
      onClick={() => { void onAccept?.(); }} aria-label={`Принять контракт: ${contract.terms.title}`}>
      <span className="route-copy"><strong>{contract.terms.title}</strong>
        <span>Помоги транспорту, подбери груз и доставь его сюда. Награда — новый боевой модуль.</span></span>
      <b>ПРИНЯТЬ КОНТРАКТ</b>
    </button> : <p className="training-dock-action">{stage === "moduleEquipped" ? equipmentAction === "inspect"
      ? `Выбери «${rewardName}» на складе.`
      : equipmentAction === "cell"
        ? "Выбери ячейку для модуля. Оставь орудие на корабле для испытания."
        : trainingInstallInstruction(replacement) :
      stage === "moduleUsed" ? "Отстыкуйся, выбери учебную мишень и испытай новый модуль." :
      stage === "return" ? "Отстыкуйся и лети к одному из мигающих порталов на карте сектора." :
      "Отстыкуйся, чтобы продолжить задание."}</p>}
  </section>;
}
